import { render, staticRenderFns } from "./info.modal.vue?vue&type=template&id=214d6377&scoped=true"
import script from "./info.modal.vue?vue&type=script&lang=js"
export * from "./info.modal.vue?vue&type=script&lang=js"
import style0 from "./info.modal.vue?vue&type=style&index=0&id=214d6377&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214d6377",
  null
  
)

export default component.exports